import axios from 'axios';
import Cookies from 'js-cookie';
import route from '@/route.js';
import { legalCookies, legalCookiesConfiguredKey, legalCookiesRejectedKey } from '@/lego/config/cookies';
import { loadFileSource, loadFunctionSource, loadStyleSource } from '@/lego/utils/dom/source';
import { inSSRContext } from '@/lego/utils/render/ssr';

export function shouldOpenBanner() {
  if (inSSRContext()) {
    return false;
  }

  return Cookies.get(legalCookiesConfiguredKey) !== '1';
}

export function getLegalCookies() {
  return legalCookies.map(cookie => {
    const cookieKey = Cookies.get(cookie.key);

    if (!cookieKey) {
      return cookie;
    }

    cookie.value = cookieKey === '1';

    return cookie;
  });
}

export function saveLegalCookie(cookie) {
  const val = cookie.required === true || cookie.value;
  Cookies.set(cookie.key, +val, { expires: 365, path: '/' });
}

export function resetLegalCookies() {
  Cookies.remove(legalCookiesRejectedKey);
  Cookies.remove(legalCookiesConfiguredKey);
}

export function saveLegalCookies(cookies) {
  resetLegalCookies();

  cookies.forEach(cookie => {
    saveLegalCookie(cookie);
  });

  saveLegalCookie({
    key: legalCookiesConfiguredKey,
    value: '1',
  });

  axios.patch(route('cookies.update'));
}

export function rejectLegalCookies() {
  saveLegalCookie({
    key: legalCookiesRejectedKey,
    value: '1',
  });

  saveLegalCookie({
    key: legalCookiesConfiguredKey,
    value: '1',
  });

  legalCookies.forEach(cookie => {
    if (!cookie.required) {
      cookie.value = false;
      saveLegalCookie(cookie);
    }
  });

  axios.patch(route('cookies.update'));
}

export function acceptAllLegalCookies() {
  resetLegalCookies();

  legalCookies.forEach(cookie => {
    cookie.value = true;
    saveLegalCookie(cookie);
  });

  saveLegalCookie({
    key: legalCookiesConfiguredKey,
    value: '1',
  });

  axios.patch(route('cookies.update'));
}

export function addCookieListener(type, source, ...params) {
  return new Promise(function(resolve, reject) {
    try {
      listenToCookie(type, function() {
        if (typeof source == 'string') {
          loadFileSource(source, ...params);
          return resolve(true);
        }

        if (typeof source == 'function') {
          loadFunctionSource(source, ...params);
          return resolve(true);
        }

        if (typeof source == 'object') {
          loadStyleSource(source, ...params);
          return resolve(true);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
}

export function listenToCookie(name, cb) {
  const cookieName = name;

  if (isCookieAccepted(cookieName)) {
    cb();
  } else if (!isCookieRejected(cookieName)) {
    onCookiesChange(function() {
      listenToCookie(name, cb);
    });
  }
}

export function cookieExists(name) {
  return !!Cookies.get(name);
}

export function isCookieAccepted(name) {
  return cookieExists(name) && Cookies.get(name) === '1';
}

export function isCookieRejected(name) {
  return cookieExists(name) && Cookies.get(name) === '0';
}

export function onCookiesChange(cb) {
  let lastCookie = document.cookie;

  const cookieInterval = setInterval(function() {
    let cookie = document.cookie;

    if (cookie !== lastCookie) {
      clearInterval(cookieInterval);

      try {
        cb();
      } finally {
        lastCookie = cookie;
      }
    }
  }, 100);
}
